import React from 'react';
import { Theme, makeStyles } from '@material-ui/core';
import { ColDef } from '@ag-grid-community/core';
import { FiSend as SendIcon } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useGetContractTemplatesQuery } from 'src/services/api';
import StandardPage from 'src/components/UI/StandardPage';
import { LoadingWrapper } from 'src/components/Loading';
import AgGrid, { TextCellRenderer } from 'src/components/AgGrid';
import { BaseActionsMenu } from 'src/components/Dropdowns';
import { FormsIcon, TrashIcon } from 'src/components/Icons';
import { RootState } from 'src/store';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(0, 4),
    marginTop: theme.spacing(3),
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      marginTop: 0,
    },
  },
}));

export const templateListcolumns: ColDef[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 520,
    sortable: true,
  },
  {
    headerName: 'Waiting for submission',
    field: 'requestsCount',
    minWidth: 200,
    sortable: true,
    cellClass: 'rightAlignedColumn',
    headerClass: 'rightAlignedHeader',
    cellRenderer: 'textCellRenderer',
  },
  {
    headerName: 'Submissions',
    field: 'submissionsCount',
    minWidth: 200,
    sortable: true,
    cellClass: 'rightAlignedColumn',
    headerClass: 'rightAlignedHeader',
    cellRenderer: 'textCellRenderer',
  },
  {
    headerName: 'Latest submission',
    field: 'latestSubmissionDate',
    minWidth: 200,
    sortable: true,
    cellClass: 'rightAlignedColumn',
    headerClass: 'rightAlignedHeader',
    cellRenderer: 'textCellRenderer',
  },
  {
    colId: 'actions',
    width: 150,
    headerName: 'Actions',
    suppressSizeToFit: true,
    pinned: 'right',
    cellRenderer: 'templateActionRenderer',
  },
];

const TemplateActionMenu = () => (
  <BaseActionsMenu
    actions={[
      {
        name: 'Share',
        icon: <SendIcon />,
        onClick: () => null, // TODO: Add share functionality
      },
      {
        name: 'Archive',
        icon: <TrashIcon />,
        onClick: () => null, // TODO: Add archive functionality
        isDelete: true,
      },
    ]}
  />
);

export const TemplateListTable = () => {
  const classes = useStyles();
  const {
    data: templates,
    isLoading: areTemplatesLoading,
  } = useGetContractTemplatesQuery();

  const searchKey = useSelector((state: RootState) => state.ui.searchValue);

  const shouldShowStandardPage = !templates || templates.length === 0;

  return (
    <LoadingWrapper isLoading={areTemplatesLoading} hideContentWhileLoading>
      {shouldShowStandardPage ? (
        <StandardPage
          topIcon={<FormsIcon style={{ fontSize: 24 }} />}
          title="No templates have been created yet"
          desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua"
        />
      ) : (
        <div className={classes.root}>
          <AgGrid
            className="agGridRowHover"
            rowData={templates}
            columnDefs={templateListcolumns}
            searchKey={searchKey}
            frameworkComponents={{
              templateActionRenderer: TemplateActionMenu,
              textCellRenderer: TextCellRenderer,
            }}
          />
        </div>
      )}
    </LoadingWrapper>
  );
};
